export default {
  extension: 'Extension',
  logout: 'Log out',
  notifications: 'Notifications',
  reminderAndNotifications: 'Reminder and notifications',
  settings: 'Settings',
};
